<!-- ============================
     NAVBAR — glassmorphism
     ============================ -->
<nav class="nav" [class.nav--scrolled]="navbarScrolled" [class.nav--menu-open]="mobileMenuOpen">
  <div class="nav__inner">
    <ul class="nav__links">
      <li><a href="#produto" (click)="scrollTo('produto', $event)">Funcionalidades</a></li>
      <li><a href="#pricing" (click)="scrollTo('pricing', $event)">Planos</a></li>
      <li><a href="#faq" (click)="scrollTo('faq', $event)">FAQ</a></li>
    </ul>

    <div class="nav__actions">
      <a [href]="appLoginUrl" class="nav__btn nav__btn--ghost">Entrar</a>
      <a [href]="appRegistroUrl" class="nav__btn nav__btn--solid">Testar grátis</a>
    </div>

    <button class="nav__hamburger" (click)="toggleMobileMenu()" aria-label="Menu">
      <span class="material-icons">{{ mobileMenuOpen ? 'close' : 'menu' }}</span>
    </button>
  </div>
</nav>

<!-- Mobile overlay -->
<div class="mobile-overlay" [class.mobile-overlay--open]="mobileMenuOpen">
  <div class="mobile-overlay__links">
    <a href="#produto" (click)="scrollTo('produto', $event)">Funcionalidades</a>
    <a href="#pricing" (click)="scrollTo('pricing', $event)">Planos</a>
    <a href="#faq" (click)="scrollTo('faq', $event)">FAQ</a>
  </div>
  <div class="mobile-overlay__cta">
    <a [href]="appLoginUrl" class="btn btn--outline btn--full">Entrar</a>
    <a [href]="appRegistroUrl" class="btn btn--solid btn--full">Testar grátis</a>
  </div>
</div>

<!-- ============================
     HERO — gradient mesh + floating orbs
     ============================ -->
<section class="hero" id="hero">
  <!-- decorative orbs -->
  <div class="hero__orb hero__orb--1"></div>
  <div class="hero__orb hero__orb--2"></div>
  <div class="hero__orb hero__orb--3"></div>

  <div class="hero__inner">
    <div class="hero__content reveal">
      <span class="hero__tag">Simples. Completo. Para você.</span>
      <h1>Seu consultório,<br><span class="hero__highlight">organizado.</span></h1>
      <p class="hero__sub">Pacientes, agenda, prontuário e financeiro — tudo em uma única plataforma feita para quem
        atende de verdade.</p>
      <div class="hero__cta">
        <a [href]="appRegistroUrl" class="btn btn--solid btn--lg" (click)="trackCta('hero')">
          Testar grátis por 15 dias
          <span class="material-icons btn__arrow">arrow_forward</span>
        </a>
        <a href="#produto" class="btn btn--ghost btn--lg" (click)="scrollTo('produto', $event)">Ver como funciona</a>
      </div>
      <p class="hero__note">Sem cartão de crédito &bull; Cancele quando quiser</p>
    </div>

    <div class="hero__visual reveal">
      <!-- Logo Stack above prints -->
      <div class="hero__logo-float">
        <img src="assets/img/identidade-visual/LogoStack.png" alt="Easy Consultório" class="hero__logo-img">
      </div>

      <div class="hero__stack">
        <div class="hero__stack-desktop">
          <img src="assets/img/ladingPage/Dashboard.png" alt="Dashboard Easy Consultório">
        </div>
        <div class="hero__stack-mobile">
          <img src="assets/img/ladingPage/ProntuarioMobile.png" alt="Prontuário mobile Easy Consultório">
        </div>
      </div>
    </div>
  </div>

  <!-- wave divider -->
  <svg class="wave wave--hero" viewBox="0 0 1440 120" preserveAspectRatio="none" aria-hidden="true">
    <path d="M0,64 C360,120 720,0 1080,64 C1260,96 1380,80 1440,64 L1440,120 L0,120 Z" fill="#ffffff" />
  </svg>
</section>

<!-- ============================
     STATS — animated counters
     ============================ -->
<section class="section section--white stats" id="stats">
  <div class="container">
    <div class="stats__grid stagger-group">
      @for (s of stats; track s.label) {
      <div class="stats__item stagger-item">
        <span class="stats__number">{{ s.value }}{{ s.suffix }}</span>
        <span class="stats__label">{{ s.label }}</span>
      </div>
      }
    </div>
  </div>
</section>

<!-- ============================
     PRODUTO — horizontal scroll cards
     ============================ -->
<section class="section section--light" id="produto">
  <div class="container">
    <div class="section__header reveal">
      <h2>Tudo que você precisa,<br><span class="gradient-text">em um só lugar.</span></h2>
    </div>
  </div>

  <!-- Horizontal scroll track (full-bleed) -->
  <div class="hscroll">
    <div class="hscroll__nav">
      <button class="hscroll__arrow hscroll__arrow--prev" (click)="scrollCarousel(-1)" aria-label="Anterior">
        <span class="material-icons">chevron_left</span>
      </button>
      <button class="hscroll__arrow hscroll__arrow--next" (click)="scrollCarousel(1)" aria-label="Próximo">
        <span class="material-icons">chevron_right</span>
      </button>
    </div>
    <div class="hscroll__track stagger-group" #carouselTrack>
      @for (f of features; track f.title) {
      <div class="hscroll__card stagger-item">
        <div class="hscroll__img">
          <img [src]="f.image" [alt]="f.title" loading="lazy">
        </div>
        <div class="hscroll__body">
          <div class="hscroll__icon">
            <span class="material-icons">{{ f.icon }}</span>
          </div>
          <h3>{{ f.title }}</h3>
          <p>{{ f.description }}</p>
        </div>
      </div>
      }
    </div>
  </div>
</section>

<!-- ============================
     DIFERENCIAL — full-bleed visual
     ============================ -->
<section class="section section--dark" id="diferencial">
  <div class="container">
    <div class="diff reveal">
      <div class="diff__content">
        <h2>Toda a jornada do paciente,<br>visível em segundos</h2>
        <p>Agenda, prontuário, financeiro e lembretes — tudo conectado em uma plataforma única. Sem alternar entre apps,
          sem perder informação.</p>
        <a [href]="appRegistroUrl" class="btn btn--white btn--lg" (click)="trackCta('mid')">Experimentar</a>
      </div>
      <div class="diff__visual">
        <div class="media-frame media-frame--tall media-frame--glow">
          <img src="assets/img/ladingPage/ProntuarioCompleto.png" alt="Prontuário completo do paciente">
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ============================
     SEGURANÇA & LGPD
     ============================ -->
<section class="section section--white" id="seguranca">
  <div class="container">
    <div class="section__header reveal">
      <h2>Segurança e privacidade<br><span class="gradient-text">em primeiro lugar.</span></h2>
    </div>

    <div class="trust__grid stagger-group">
      <div class="trust__card stagger-item">
        <div class="trust__icon trust__icon--purple">
          <span class="material-icons">verified_user</span>
        </div>
        <h3>Privacidade levada a sério</h3>
        <p>Todos os dados são tratados conforme a Lei Geral de Proteção de Dados (LGPD), com controle de acesso e criptografia ponta a ponta.</p>
      </div>

      <div class="trust__card stagger-item">
        <div class="trust__icon trust__icon--blue">
          <span class="material-icons">cloud_done</span>
        </div>
        <h3>Infraestrutura segura e confiável</h3>
        <p>Hospedado na Microsoft Azure, com criptografia avançada, backups automáticos diários e alta disponibilidade garantida.</p>
      </div>

      <div class="trust__card stagger-item">
        <div class="trust__icon trust__icon--cyan">
          <span class="material-icons">admin_panel_settings</span>
        </div>
        <h3>Controle total de acesso</h3>
        <p>Cada usuário acessa apenas os seus próprios dados. Sessões protegidas com autenticação segura e tokens criptografados.</p>
      </div>
    </div>
  </div>
</section>

<!-- ============================
     PRICING — single plan, glassmorphism card
     ============================ -->
<section class="section section--mesh" id="pricing">
  <!-- decorative -->
  <div class="mesh-orb mesh-orb--1"></div>
  <div class="mesh-orb mesh-orb--2"></div>

  <div class="container">
    <div class="section__header reveal">
      <h2>Teste tudo. Grátis por 15 dias.</h2>
      <p class="section__sub">Sem cartão de crédito. Sem compromisso. Sem pegadinhas.</p>
    </div>

    <div class="price-card reveal">
      <div class="price-card__badge">Acesso completo</div>

      <div class="price-card__trial">
        <span class="price-card__trial-label">15 dias grátis</span>
        <span class="price-card__trial-sub">para testar tudo, sem compromisso</span>
      </div>

      <div class="price-card__divider"></div>

      <div class="price-card__regular">
        <span class="price-card__regular-label">Depois do período de teste</span>
        <div class="price-card__regular-price">
          <span class="price-card__currency">R$</span>
          <span class="price-card__value">59</span>
          <span class="price-card__period">/mês</span>
        </div>
      </div>

      <div class="price-card__features stagger-group">
        @for (f of planFeatures; track f.label) {
        <div class="price-card__feat stagger-item">
          <span class="material-icons">{{ f.icon }}</span>
          <span>{{ f.label }}</span>
        </div>
        }
      </div>

      <a [href]="appRegistroUrl" class="btn btn--solid btn--lg btn--full" (click)="trackCta('pricing')">Testar grátis por 15 dias</a>
      <p class="price-card__note">Cancele quando quiser. Sem multas.</p>
    </div>
  </div>
</section>

<!-- ============================
     FAQ — clean accordion
     ============================ -->
<section class="section section--light" id="faq">
  <div class="container container--narrow">
    <div class="section__header reveal">
      <span class="section__tag">FAQ</span>
      <h2>Perguntas frequentes</h2>
    </div>

    <div class="faq stagger-group">
      @for (item of faqs; track item.question; let i = $index) {
      <div class="faq__item stagger-item" [class.faq__item--open]="activeFaq === i">
        <button class="faq__q" (click)="toggleFaq(i)">
          <span>{{ item.question }}</span>
          <span class="material-icons faq__chevron">expand_more</span>
        </button>
        @if (activeFaq === i) {
        <div class="faq__a">{{ item.answer }}</div>
        }
      </div>
      }
    </div>
  </div>
</section>

<!-- ============================
     FOOTER
     ============================ -->
<footer class="footer">
  <div class="footer__inner">
    <div class="footer__grid">
      <div class="footer__brand">
        <a href="#" (click)="scrollTo('hero', $event)" class="footer__logo-link">
          <img src="assets/img/identidade-visual/LogoPretoEBranco.png" alt="EasyConsultório" class="footer__logo">
        </a>
        <p>Seu consultório, organizado.<br>Tudo sobre seus pacientes, em um só lugar.</p>
      </div>

      <div class="footer__col">
        <h4>Navegação</h4>
        <a href="#produto" (click)="scrollTo('produto', $event)">Funcionalidades</a>
        <a href="#pricing" (click)="scrollTo('pricing', $event)">Planos</a>
        <a href="#faq" (click)="scrollTo('faq', $event)">FAQ</a>
      </div>

      <!-- <div class="footer__col">
        <h4>Legal</h4>
        <a href="#">Termos de uso</a>
        <a href="#">Política de privacidade</a>
      </div> -->

      <div class="footer__col">
        <h4>Contato</h4>
        <span>suporte&#64;easyconsultorio.com.br</span>
        <span>Seg–Sex, 9h às 18h</span>
      </div>
    </div>

    <div class="footer__bottom">
      <p>&copy; 2026 Easy Consultório. Todos os direitos reservados.</p>
    </div>
  </div>
</footer>